"use client"

import { Fragment } from "react"
import Script from "next/script"

import useLang from "~/hooks/useLang"
import Icon from "~/components/abstracts/Icon"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { useInternalRedirects } from "~/providers/InternalRedirectsProvider/index.client"

import * as css from "./styles.css"

export function AccessiwayWidgetScript() {
  const lang = useLang()
  const t = useTranslate()
  const [redirects] = useInternalRedirects()
  const accessibilityStatementHref = redirects?.accessibilityStatement?.href ?? "/"

  return (
    <Fragment>
      <Script
        id="accessiway-widget"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
        (function(){
          var s = document.createElement('script'),
          e = !document.body ? document.querySelector('head') : document.body;

          s.src = 'https://eu.acsbapp.com/apps/app/dist/js/app.js';
          s.async = true;
          s.onload = function(){
            acsbJS.init({
              statementLink: '${accessibilityStatementHref}',
              footerHtml: '<a href="https://www.accessiway.fr/" target="_blank">AccessiWay. The Web Accessibility Solution</a>',
              hideMobile: true,
              hideTrigger: true,
              language: '${lang}',
              position: 'left',
              leadColor: '#000',
              triggerColor: '#000',
              triggerRadius: '50%',
              triggerPositionX: 'left',
              triggerPositionY: 'bottom',
              triggerIcon: 'people',
              triggerSize: 'small',
              triggerOffsetX: 20,
              triggerOffsetY: 20,
              mobile: {
                triggerSize: 'small',
                triggerPositionX: 'left',
                triggerPositionY: 'bottom',
                triggerOffsetX: 10,
                triggerOffsetY: 10,
                triggerRadius: '50%'
              }
            });
          };
          e.appendChild(s);
        }());
      `,
        }}
      />
      <button
        className={css.customTriggerButton}
        data-acsb="trigger"
        tabIndex={0}
        aria-label={t("aria_label_accessiway")}
      >
        <Icon direction="right" theme="white" name="Accessiway" className={css.customTriggerButtonIcon} />
      </button>
    </Fragment>
  )
}
